const cancelInvoiceInstallment = {
  'cancelInvoiceInstallment.title': 'Cancelar Parcelamento de Fatura',
  'cancelInvoiceInstallment.emptyState':
    'Não há parcelamento de fatura para cancelar.',
  'cancelInvoiceInstallment.errorState':
    'Ocorreu um erro e não foi possível obter os dados do parcelamento de fatura.',
  'cancelInvoiceInstallment.confirm': 'Confirmar',
  'cancelInvoiceInstallment.outcomeSuccess': 'Parcelamento de Fatura cancelada',
  'cancelInvoiceInstallment.close': 'Fechar',

  'cancelInvoiceInstallment.firstPaymentDate': 'Data de pagamento da entrada',
  'cancelInvoiceInstallment.firstPaymentAmount': 'Valor da entrada',
  'cancelInvoiceInstallment.numberInstallments':
    'Número de parcelas contratadas',
  'cancelInvoiceInstallment.contractAmount': 'Valor total do contrato',
  'cancelInvoiceInstallment.principalAmount': 'Valor financiado',
  'cancelInvoiceInstallment.installmentAmount': 'Valor da parcela',
  'cancelInvoiceInstallment.interestRate': 'Taxa de juros do parcelamento',
};

export default cancelInvoiceInstallment;
